import { render } from "./ClassgroupCreate.vue?vue&type=template&id=5faff364&ts=true"
import script from "./ClassgroupCreate.vue?vue&type=script&lang=ts"
export * from "./ClassgroupCreate.vue?vue&type=script&lang=ts"

import "./ClassgroupCreate.vue?vue&type=style&index=0&id=5faff364&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/com.latudio.www.teachers_staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__